import { ApplicationError } from '../errors';

export class PageValidationErrors extends ApplicationError {
    public readonly validationErrors: { [key: string]: string[] } = {};

    public constructor(validationErrors: { [key: string]: string[] }) {
        super('PageValidationErrors', 'Page valdation errors');
        this.validationErrors = validationErrors;
    }
}

export class PasswordValidationErrors extends ApplicationError {
    public readonly validationErrors: string[] = [];

    public constructor(message: string, validationErrors: string[]) {
        super('PasswordValidationErrors', message);
        this.validationErrors = validationErrors;
    }
}

export const GENERIC_PING_PASSWORD_ERROR =
    'The password you entered is not secure enough or has been used previously. Please enter a different password';

export class AccountLockedError extends ApplicationError {
    public constructor() {
        super(
            'AccountLockedError',
            `Your account has been locked as there have been too many attempts to enter your current password.`
        );
    }
}

export class UnauthorisedError extends ApplicationError {
    public constructor() {
        super('UnauthorisedError', `The password entered does not match your current password`);
    }
}
